function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}



const pageIdentifier = window.location.pathname.replace(/\//g, '_');
const imageElements = document.querySelectorAll('.switchingImage');
imageElements.forEach((imageElement, index) => {
    const anchorElement = imageElement.closest('a');
    const currentSrc = imageElement.getAttribute('src');
    const dataSecond = imageElement.getAttribute('data-second');
    const cookieNameImage = `lastImage_${pageIdentifier}_${index}`;
    const lastImage = getCookie(cookieNameImage);
    
    if (lastImage === currentSrc) {
        imageElement.setAttribute('src', dataSecond);
        setCookie(cookieNameImage, dataSecond, 30);
    } else {
        imageElement.setAttribute('src', currentSrc);
        setCookie(cookieNameImage, currentSrc, 30);
    }    

    // Handling the URL switching
    const currentHref = anchorElement.getAttribute('href');
    const dataSecondHref = anchorElement.getAttribute('data-second');
    const cookieNameUrl = `lastUrl_${pageIdentifier}_${index}`;
    const lastUrl = getCookie(cookieNameUrl);

    if (lastUrl === currentHref) {
        anchorElement.setAttribute('href', dataSecondHref);
        setCookie(cookieNameUrl, dataSecondHref, 30);
    } else {
        anchorElement.setAttribute('href', currentHref);
        setCookie(cookieNameUrl, currentHref, 30);
    }    
});
